<template>
    <div id="modalAudit" class="modal fade" role="dialog" aria-labelledby="modalAudit" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content animated bounceIn">
          <div class="modal-header" style="border-bottom: 1px solid transparent; padding-top:0px !important; padding-bottom:0px !important;">
            <div class="row" style="padding-top: 15px;">
              <div class="col-xs-10 col-lg-7 col-md-7 col-sm-6" style="text-align: left;">
                <h2 style="margin-bottom:3px !important;">
                  {{$t('view.auditoria.main.titulo.label')}}
                  <span></span>
                </h2>
              </div>
              <div id="identifiers" class="col-xs-10 col-lg-3 col-md-3 col-sm-3" style="text-align: left;">
                <h2 style="margin-bottom:3px !important;">
                  {{$t('view.auditoria.main.clave.label')}}: <span id="audit_clave"></span>
                </h2>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-3"
                style="text-align: right;">
                <button id="btnCloseModal" type="button" title="Cerrar"
                  class="btn btn-outline btn-circle btn-md btn-sm btn-primary modal-close-sm modal-audit-close"
                  data-dismiss="modal" style="border-radius: 50%; ">
                  <i class="menu-item-icon button__icon icon mdi mdi-close fa-lg"></i>
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-10 col-lg-7 col-md-7 col-sm-6" style="text-align: left;">
                <ol id="audit_breadcrumb" class="breadcrumb">
                  <li>{{$t('view.auditoria.main.titulo.label')}}</li>
                  <li class="active"><strong id="audit_tabla"></strong></li>
                </ol>
              </div>
              <div id="identifiers" class="col-xs-12 col-lg-5 col-md-5 col-sm-5" style="text-align: left;">
                <h4 id="audit_descripcion_div" style="margin-bottom:3px !important;">
                  {{$t('view.auditoria.main.descripcion.label')}}: <span id="audit_descripcion"></span>
                </h4>
              </div>
            </div>
          </div>
          <div class="modal-body" style="overflow: hidden; background-color: white; padding-top:0px !important; padding-bottom:0px !important;">
            <div id="modalAuditContent">
              <div id="main-audit" class="animated fadeInRight">
                <div class="col-lg-12">
                  <article class="col-sm-12">
                  </article>
                  <div class="row">
                    <div class="col-md-12"></div>
                    <h3 style="margin-bottom: 5px !important;">
                      {{$t('view.auditoria.main.subtitulo.label')}}
                    </h3>
                  </div>
                  <div class="row">
                    <div class="table-responsive">
                      <table id="dataTableAudit"
                        class="table table-striped table-bordered dt-responsive responsive table-hover changes-datatable" style="width: 100%">
                        <thead>
                          <tr>
                            <th class="all">{{$t('view.auditoria.main.revision.th')}}</th>
                            <th class="all">{{$t('view.auditoria.main.usuario.th')}}</th>
                            <th class="all">{{$t('view.auditoria.main.fecha.th')}}</th>
                            <th class="all">{{$t('view.auditoria.main.hora.th')}}</th>
                            <th class="all">{{$t('view.global.th.accion.text')}}</th>
                          </tr>
                        </thead>
                        <tbody>                          
                         
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div id="audit" class="white-bg" style="max-height: auto; overflow-y: visible; padding-left:0px;">
                <div id="audit-content">
                  <div id="detailAudit" class="animated fadeInLeft" style="display:none;">
                    <div class="col-xs-12" id="btn-back-div" style="padding:0px;">
                      <button id="back-audit" class="btn btn-action-edit button button--sacnite button--round-l custom" title="Volver">
                        <i class="button__icon icon fa fa-arrow-left"></i>
                        <span>back</span>
                      </button>
                      <h1 class="text-center m-t-none">
                        <small>{{$t('view.auditoria.detail.subtitulo.label')}}</small>
                      </h1>
                    </div>
                    <div class="col-md-12 col-lg-12 col-xs-12 " style="padding:0px;">			
                      <div class="table-responsive ">
                        <table id="dataTableAuditDetail" class="table table-striped table-bordered table-hover" style="width:100%">
                          <thead>
                            <tr>
                              <th class="text-center all">{{$t('view.auditoria.detail.campos.th')}}</th>
                              <th class="text-center all">{{$t('view.auditoria.detail.anterior.th')}}</th>
                              <th class="text-center all">{{$t('view.auditoria.detail.seleccionada.th')}}</th>						
                            </tr>
                          </thead>
                          <tbody>
                          </tbody>
                        </table>		
                      </div>
                      <div class="text-center">
                        <p id="sinRevision" style="width:100%"></p>
                      </div>                      
                      <div class="widget-body-toolbar">
                      </div>
                    </div>
                  </div>
                </div>
                <div id="backPopUp" class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-left:5px;"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>

import AuditoriaAPI from "@/services/bitacoras/auditoria";
import tippy from 'tippy.js';
import {formatDate} from '@/helpers/date-methods';
import {getAccounting} from '@/helpers/form-common';
import numeral from 'numeral';

//Element's Settings
const button = {
  submit:{
    enable:true
    , text:""
    , class:{
      current:""
      , save:"button__icon icon fa fa-plus"
      , update:"button__icon icon fa fa-check"
    }
    , data:{
       id: 0
    }
  }
  , clear:{
    visible:false
  }
  , audit:{
    visible:false
  }
  
};
//Action's state
const action = {
  submit:{
    busy:false
  }
};

export default {
  data() {
   let _locale = this.$store.language;
    return {
      locale: _locale
      , view:{
        title:"Auditoría"
        , action
        , elem:{
          button
        }
      }
      , dataTable: undefined
      , listado: []
      , listadoDetalle:[]
    }
  }
  , props:{
   
  }
  ,methods: {
    
      async loadAudit(auditoria){
        const {clave,tabla,descripcion,revision} = auditoria;
        try
        {

          const response = await AuditoriaAPI.get({clave,tabla,descripcion,revision});    
          this.listado = response.data.results.lista;
          let modalAudit = document.getElementById('modalAudit');

          //Event on hide
          modalAudit.addEventListener('hidden.bs.modal', function(event){
              window.$('#dataTableAudit').dataTable().fnDestroy();
              window.$('#dataTableAuditDetail').dataTable().fnDestroy();
              document.getElementById('main-audit').style.display = 'block';
              document.getElementById('detailAudit').style.display = 'none';        

          }, false);

          let modalAuditInstance = new Modal(modalAudit, 
          { 
            backdrop: 'static', 
            keyboard: true 
          });

          document.getElementById('audit_clave').innerText= response.data.results.clave;
          document.getElementById('audit_descripcion').innerText= response.data.results.descripcion;
          document.getElementById('audit_descripcion_div').style.display= 'block';
          document.getElementById('audit_tabla').innerText= response.data.results.tabla;          

          let auditTBody = document.getElementById('dataTableAudit').getElementsByTagName('tbody')[0];

          auditTBody.innerHTML='';
          console.log(response.data.results);
          
          response.data.results.lista.forEach(function(obj) {
              // Insert a row in the table at the last row
            var length = auditTBody.rows.length;
            var newRow   = auditTBody.insertRow(length);

            newRow.insertCell(0).append(document.createTextNode(obj.revision));
            newRow.insertCell(1).append(document.createTextNode(obj.user));
            newRow.insertCell(2).append(document.createTextNode(formatDate(obj.revisionDate)));
            newRow.insertCell(3).append(document.createTextNode(obj.revisionTime));
            newRow.insertCell(4).append(newEditButton(clave,tabla,descripcion,obj.revision));
            newRow.cells[4].setAttribute('class','text-center');
          
          });

          document.getElementById('main-audit').style.display = 'block';
          document.getElementById('detailAudit').style.display = 'none';  
          modalAuditInstance.show();        
          
          window.$('#dataTableAudit').dataTable({
            "responsive": true
            , "language": { "url": '/static/js/dataTables/language/dataTables.spanish.json' }
            ,  "order": [[ 0, "desc" ]]
            , "fnDrawCallback": function (oSettings) {
              tippy('.btn', {
                arrow: true,
                arrowType: 'round',
                size: 'large',
                animation: 'scale'
              });
            }
          });         

          setTimeout( () => document.getElementById('dataTableAudit').parentNode.setAttribute("style","max-height:200px; overflow-y: scroll;")
          , 800);

      } 
      catch(error)
      {
       console.log(error);
      }
    }
    , loadAuditMainDetail(auditoria){
        const {clave,tabla,descripcion,revision} = auditoria;
        let modalAudit = document.getElementById('modalAudit');

        //Event on hide
        modalAudit.addEventListener('hidden.bs.modal', function(event){
            window.$('#dataTableAudit').dataTable().fnDestroy();
            window.$('#dataTableAuditDetail').dataTable().fnDestroy();
            document.getElementById('main-audit').style.display = 'block';
            document.getElementById('detailAudit').style.display = 'none';        

        }, false);

        let modalAuditInstance = new Modal(modalAudit, 
        { 
          backdrop: 'static', 
          keyboard: true 
        });

        document.getElementById('audit_clave').innerText=clave;
        document.getElementById('audit_descripcion').innerText= descripcion;
        document.getElementById('audit_tabla').innerText= tabla;

        loadAuditDetails({clave:clave,tabla:tabla,descripcion:descripcion,revision:revision});

        document.getElementById('back-audit').style.display = 'none';
        document.getElementById('main-audit').style.display = 'none';
        document.getElementById('detailAudit').style.display = 'block';  
        modalAuditInstance.show();        
        

      return false;
    }
  }
  , computed:{

    
  }
  // Instance Lifecycle Hooks
  , created(){
    //window.$('.dataTables-example').DataTable({});  
  }
  , mounted(){
    const vaudit = this;
    this.$nextTick(function(){    
      document.getElementById('back-audit').onclick =backToMain;      
    });
    this.$nextTick(function(){
      tippy('.btn', {
            arrow: true,
            arrowType: 'round',
            size: 'large',
            animation: 'scale'
          });
    });
  },
  updated(){
    this.$nextTick(function(){
      tippy('.btn', {
            arrow: true,
            arrowType: 'round',
            size: 'large',
            animation: 'scale'
          });
  });
  }
};

function backToMain(event){
  event.preventDefault();
    document.getElementById('main-audit').style.display = 'block';  
    document.getElementById('detailAudit').style.display = 'none';     
    window.$('#dataTableAuditDetail').dataTable().fnDestroy();  
  return false;
}
  
function newEditButton(clave,tabla,descripcion,revision){
  const button = document.createElement('button');
  const link = document.createElement('i');
  const label = document.createElement('span');
  //button settings
  button.setAttribute("title","Ver Detalle");
  button.classList.add('btn', 'btn-action-edit', 'button', 'button--sacnite', 'button--round-l', 'custom','btn-audit-detail');
  button.revision = revision || "";
  button.clave = clave || "";
  button.tabla = tabla || "";
  button.descripcion = descripcion || "";
  button.onclick = loadAuditDetail;
  //link
  link.classList.add('button__icon', 'icon', 'mdi', 'mdi-magnify');
  //label settings
  label.appendChild(document.createTextNode('edit'))
  //Append link and label within the button
  button.appendChild(link);
  button.appendChild(label);
  
  return button;
};
function builIElement(color)
{
  let iElement = document.createElement('i');
  iElement.setAttribute('class','fa fa-circle fa-2x');
  iElement.setAttribute('aria-hidden','true');
  iElement.setAttribute('style','color:'+color+';');
  return iElement;
}
function buildImgElement(imageSrc,width, classes)
{
  let img = document.createElement('img');
  img.setAttribute('src',imageSrc);
  img.setAttribute("width",width);
  img.setAttribute("class",classes);
  return img;
}
function buildHtmlElement(htmlString)
{
  var div = document.createElement('div');
  div.innerHTML = htmlString.trim();
  return div; 
}
function builRateElement(rate)
{
  let wrap = document.createElement('div');
  for(var i = 0; i < rate; i++)
  {
    let iElement = document.createElement('i');
    iElement.setAttribute('class','fa fa-star');
    iElement.setAttribute('aria-hidden','true');
    iElement.setAttribute('style','color:#0077BC !important; text-shadow: -.5px 0 #585858, 0 1px #585858, .5px 0 #585858, 0 -.5px #585858 !important;');
    wrap.appendChild(iElement);
  }
  
  return wrap;
}
function loadAuditDetail(event){
  event.preventDefault();
    loadAuditDetails({clave:this.clave,tabla:this.tabla,descripcion:this.descripcion,revision:this.revision});
  return false;
}
function mapAuditDetailsByType(obj, newRow){
  
   if(obj.type === 'java.math.BigDecimal')
  {
    newRow.insertCell(1).append(document.createTextNode(getAccounting().formatMoney(obj.secondCompare)));
    newRow.insertCell(2).append(document.createTextNode(getAccounting().formatMoney(obj.firstCompare)));
  }
  else {
    newRow.insertCell(1).append(document.createTextNode(obj.secondCompare));
    newRow.insertCell(2).append(document.createTextNode(obj.firstCompare));
  }

}
function getTipoMultimedia(data){
  switch(data){
    case 'none':
    return 'Ninguno';
    case 'img':
    return 'Imagen';
    case 'video':
    return 'Video';
    case 'archivo':
    return 'Archivos';
    default:
    return '';
  }
}
function getNombresArchivos(archivos){
  if(archivos != null && archivos != ''){
    if(archivos.includes(',')){
      let archivosArray = archivos.split(',');
      let archivosNombres = []; 
      archivosArray.forEach(function(archivo){
        archivosNombres.push(archivo.split(':')[1]);
      });
      return archivosNombres.join(', ');
    }
    else {
      return archivos.split(':')[1];
    }
  }
  else {
    return '';
  }
}
function loadAuditDetails(auditoria){
  const {clave,tabla,descripcion,revision} = auditoria;
        try{
          
          const response =  AuditoriaAPI.details({clave,tabla,descripcion,revision});     
          document.getElementById('dataTableAuditDetail').style.display = 'table'; 
          document.getElementById('sinRevision').innerText = '';   
          
          response.then(function(dataResult){ 
            console.log(dataResult);
          
            let auditDetailTBody = document.getElementById('dataTableAuditDetail').getElementsByTagName('tbody')[0];

            auditDetailTBody.innerHTML='';
            if(dataResult.data.meta.code === 'OK' && dataResult.data != null && dataResult.data.results != null && dataResult.data.results.lista != null)
            {
              dataResult.data.results.lista.forEach(function(obj) {
                // Insert a row in the table at the last row
                let length = auditDetailTBody.rows.length;
                let newRow   = auditDetailTBody.insertRow(length);
                newRow.insertCell(0).append(document.createTextNode(obj.fields));

                if(obj.fields === 'Color')
                {
                  newRow.insertCell(1).append(builIElement(obj.secondCompare));
                  newRow.insertCell(2).append(builIElement(obj.firstCompare));
                  newRow.cells[1].setAttribute('class','text-center');
                  newRow.cells[2].setAttribute('class','text-center');
                }
                else if(obj.fields === 'Foto')
                {                 
                  newRow.insertCell(1).append(buildImgElement(obj.secondCompare,"60px", "img-circle animated picture-pulse"));
                  newRow.insertCell(2).append(buildImgElement(obj.firstCompare,"60px", "img-circle animated picture-pulse"));
                  newRow.cells[1].setAttribute('class','text-center');
                  newRow.cells[2].setAttribute('class','text-center');
                }
                else if(obj.fields === 'Prioridad')
                {
                  newRow.insertCell(1).append(builRateElement(obj.secondCompare));
                  newRow.insertCell(2).append(builRateElement(obj.firstCompare));
                  newRow.cells[1].setAttribute('class','text-center');
                  newRow.cells[2].setAttribute('class','text-center');
                }
                else if(obj.fields === 'Ruta de la imagen')
                {
                  newRow.insertCell(1).append(buildImgElement(obj.secondCompare,"120px", "animated picture-pulse"));
                  newRow.insertCell(2).append(buildImgElement(obj.firstCompare,"120px", "animated picture-pulse"));
                  newRow.cells[1].setAttribute('class','text-center');
                  newRow.cells[2].setAttribute('class','text-center');
                }
                else if(obj.fields === 'Cuerpo' || obj.fields === 'Descripción')
                {
                  newRow.insertCell(1).append(buildHtmlElement(obj.secondCompare));
                  newRow.insertCell(2).append(buildHtmlElement(obj.firstCompare));
                  newRow.cells[1].setAttribute('class','text-center');
                  newRow.cells[2].setAttribute('class','text-center');
                }
                else if(obj.type === 'java.util.Date')
                {
                  newRow.insertCell(1).append(obj.secondCompare != ""? formatDate(obj.secondCompare) : "");
                  newRow.insertCell(2).append(obj.firstCompare != ""? formatDate(obj.firstCompare) : "");
                }
                else if(obj.fields.includes('Contraseña'))
                {
                  
                  newRow.insertCell(1).append(buildHtmlElement(`<input type="password" value=${obj.secondCompare} readonly />`));
                  newRow.insertCell(2).append(buildHtmlElement(`<input type="password" value=${obj.firstCompare} readonly />`));
                }
                else 
                {
                  newRow.insertCell(1).append(document.createTextNode(obj.secondCompare));
                  newRow.insertCell(2).append(document.createTextNode(obj.firstCompare));
                }
                
                
                
                
                
               

              });

              window.$('#dataTableAuditDetail').dataTable({
                "responsive": true
                , "language": { "url": '/static/js/dataTables/language/dataTables.spanish.json' }
              });

              setTimeout( () => document.getElementById('dataTableAuditDetail').parentNode.setAttribute("style","max-height:200px; overflow-y: scroll;")
              , 800);

            }
            else  {
              //imprimir error
              document.getElementById('dataTableAuditDetail').style.display = 'none';  
              document.getElementById('sinRevision').innerText = 'No existe registro contra el cual comparar';              
            }
            document.getElementById('main-audit').style.display = 'none';
            document.getElementById('detailAudit').style.display = 'block'; 
            console.dir();
          }, function(error){console.log(error);});

                
        
      } 
      catch(error)
      {
       console.log(error);
      }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/auditoria/Auditoria.vue